var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"good-btn",class:_vm.size,on:{"click":_vm.favFunc}},[_c('span',{staticClass:"btn-msg",class:{'text-red': _vm.hadFav}},[_vm._v(_vm._s(_vm.hadFav? '已收藏': '收藏'))]),(_vm.showCount)?_c('span',{staticClass:"count"},[_vm._v(_vm._s(_vm.localGoodCount))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }